import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { X, MapPin, Search, Home } from "lucide-react";
import { api } from "../lib/api";
import { useCity, cityDelay, citySlug } from "../context/CityContext";

export function CityModal() {
  const { chooseCity, modalOpen, setModalOpen } = useCity();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const [q, setQ] = useState("");

  const pickCity = (name) => {
    chooseCity(name);
    navigate(`/livraison-cbd/${citySlug(name)}`);
  };

  // Jamais d'ouverture automatique : la fenêtre s'ouvre uniquement au clic sur « Ta ville » / « Choisir ma ville ».
  useEffect(() => { setModalOpen(false); }, [pathname, setModalOpen]);

  useEffect(() => {
    if (modalOpen && cities.length === 0) {
      api.get("/cities").then((r) => setCities(Array.isArray(r.data) ? r.data : [])).catch(console.error);
    }
  }, [modalOpen, cities.length]);

  if (!modalOpen) return null;
  const norm = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const filtered = cities.filter((c) => norm(c.name).includes(norm(q)));

  return (
    <div className="fixed inset-0 z-[90] bg-black/85 flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={() => setModalOpen(false)}>
      <div data-testid="city-modal" className="bg-ink-surface border border-zinc-700 w-full max-w-md max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between p-5 pb-3">
          <div>
            <h2 className="font-anton text-2xl uppercase text-white">On livre <span className="neon-text-green">chez toi ?</span></h2>
            <p className="text-zinc-500 text-xs mt-1">Choisis ta ville pour voir les délais et commander auprès de ton livreur local.</p>
          </div>
          <button data-testid="city-modal-close" onClick={() => setModalOpen(false)} className="text-zinc-500 hover:text-white p-1"><X className="h-5 w-5" /></button>
        </div>
        <div className="relative px-5 pb-3">
          <Search className="absolute left-8 top-1/2 -translate-y-[70%] h-4 w-4 text-zinc-500" />
          <input
            data-testid="city-modal-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Cherche ta ville…"
            autoFocus
            className="w-full bg-ink border border-zinc-700 text-white pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:border-neon-green"
          />
        </div>
        <div className="overflow-y-auto px-5 pb-5 space-y-1.5" data-testid="city-modal-list">
          {!q && (
            <button
              data-testid="city-modal-home"
              onClick={() => { setModalOpen(false); navigate("/"); }}
              className="w-full flex items-center justify-between border border-neon-magenta/60 hover:border-neon-magenta bg-neon-magenta/10 px-3 py-2.5 text-left transition-colors group"
            >
              <span className="flex items-center gap-2 text-neon-magenta text-sm font-anton uppercase tracking-wide">
                <Home className="h-4 w-4" /> Accueil
              </span>
              <span className="text-neon-magenta text-xs font-bold">Toutes les villes →</span>
            </button>
          )}
          {filtered.map((c) => {
            const d = cityDelay(c.name);
            return (
              <button
                key={c.name}
                data-testid="city-modal-option"
                onClick={() => pickCity(c.name)}
                className="w-full flex items-center justify-between border border-zinc-800 hover:border-neon-green bg-ink px-3 py-2.5 text-left transition-colors group"
              >
                <span className="flex items-center gap-2 text-white text-sm font-semibold">
                  <MapPin className="h-4 w-4 text-neon-magenta" /> {c.name}
                  {c.live_count > 0 && <span className="h-1.5 w-1.5 rounded-full bg-neon-green animate-pulse" />}
                </span>
                <span className="text-neon-green text-xs font-bold group-hover:text-black group-hover:bg-neon-green px-1.5 py-0.5 transition-colors">{d ? `~${d} min` : "< 2h"}</span>
              </button>
            );
          })}
          {filtered.length === 0 && <p className="text-zinc-500 text-sm py-3">Pas encore chez toi — commande en <a href="/boutique/national" className="text-neon-magenta underline">colis discret 48h</a> 📦</p>}
        </div>
      </div>
    </div>
  );
}
